import React from "react";
import { Button } from "./../../Atoms/Button/Button";
import content from "../../Pages/CommonQuestions/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const CommonQuestionsHeader = () => {
  const {language} = useLanguageCtx();

  return (
		<div className="max-width top-space-section bottom-space-section">
			<h2 className="t2 center-text no-space mb-20">
				{content[language].preguntas_title}
			</h2>
			<div className="all-width flex wrap space-around">
				<div className="mt-20">
					<Button
						type="button light-gray outline"
						content={content[language].categoria_1}
						width="125px"
					/>
				</div>
				<div className="mt-20">
					<Button
						type="button light-gray"
						content={content[language].categoria_2}
						width="125px"
					/>
				</div>
				<div className="mt-20">
					<Button
						type="button light-gray"
						content={content[language].categoria_3}
						width="125px"
					/>
				</div>
				<div className="mt-20">
					<Button
						type="button light-gray"
						content={content[language].categoria_4}
						width="125px"
					/>
				</div>
				<div className="mt-20">
					<Button
						type="button light-gray"
						content={content[language].categoria_5}
						width="125px"
					/>
				</div>
				<div className="mt-20">
					<Button
						type="button light-gray"
						content={content[language].categoria_6}
						width="125px"
					/>
				</div>
			</div>
		</div>
	);
};

export default CommonQuestionsHeader;
